import React from 'react'
import classNames from 'classnames'
import { AsSpan, CaptionXS, LabelMD } from '@/atoms/Text'
import { useTranslate } from '@/utils/translate/translate-client'
import { useTimeLeft } from '@/utils/useTimeLeft/useTimeLeft'

export interface GuildPromotionCountdownProps {
  endDate: string
  className?: string
}
export const GuildPromotionCountdown: React.FC<GuildPromotionCountdownProps> = ({ endDate, className }) => {
  const { t } = useTranslate('common')
  const timeLeft = useTimeLeft({ targetDate: new Date(endDate) })

  return (
    <div className={classNames('flex items-center gap-4 rounded-xl', className)}>
      <UnitDisplay value={timeLeft.days} label={t('day', 'days')} />
      <UnitDisplay value={timeLeft.hours} label={t('abbreviatedHours', 'hrs')} />
      <UnitDisplay value={timeLeft.minutes} label={t('abbreviatedMinutes', 'mins')} />
      <UnitDisplay value={timeLeft.seconds} label={t('abbreviatedSeconds', 'sec')} />
    </div>
  )
}

interface UnitDisplayProps {
  value: number
  label: string
}
const UnitDisplay: React.FC<UnitDisplayProps> = ({ value, label }) => {
  return (
    <div className="flex h-[40px] w-[32px] flex-col items-center justify-center rounded-lg bg-core-gray-200 p-2">
      <LabelMD as={AsSpan} color="core-gray-950" weight="bold">
        {value}
      </LabelMD>
      <CaptionXS weight="semibold" as={AsSpan} className="uppercase" color="core-gray-700">
        {label}
      </CaptionXS>
    </div>
  )
}
